import { IconButton, Show, Tooltip, Hide } from '@vimeo/bokeh';
import { CloseX } from '@vimeo/bokeh-icons';
import { useLayout } from '@vimeo/clip-ui/hooks/use-layout';
import { translate } from '@vimeo/i18n-runtime';
import { LayoutToggleIcon } from '@vimeo/viewer-showcase-ui/components/LayoutToggle';

import { LayoutToggleProps, useLayoutToggle } from '../hooks/use-layout-toggle';

export const LayoutToggle = (props: LayoutToggleProps) => {
  const { isSideModuleOpen, onClose } = useLayout();
  const { layoutToggleTooltipText, layoutIconTransform, onToggleClick } = useLayoutToggle(props);

  return (
    <>
      <Hide above="md">
        <Tooltip label={translate('Close')} placement="top">
          <IconButton
            aria-label={translate('Close')}
            icon={<CloseX />}
            size="sm"
            variant="minimal"
            onClick={onClose}
          />
        </Tooltip>
      </Hide>
      {!isSideModuleOpen ? (
        <Show above="md">
          <LayoutToggleIcon
            label={layoutToggleTooltipText}
            onClick={onToggleClick}
            transform={layoutIconTransform}
          />
        </Show>
      ) : null}
    </>
  );
};
